import {
  Box,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { APP_ICONS } from "../../assets";

const PaperContainer = ({
  title,
  onBack,
  children,
  subtitle,
  childrenProps,
  showBackButton,
  headerActions,
  searchActions,
}) => {
  return (
    <Paper sx={{ borderRadius: "6px", height: "100%" }}>
      <Stack
        p={2}
        gap={{ xs: 1, md: 0 }}
        flexDirection={{ md: "row" }}
        alignItems={{ md: "center" }}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"} flex={1}>
          {showBackButton ? (
            <IconButton
              onClick={onBack}
              disableRipple
              sx={{
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <img
                src={APP_ICONS.backPurpleIcon}
                alt={"card-icon"}
                width={25}
                height={25}
              />
            </IconButton>
          ) : (
            <img
              src={APP_ICONS.fourArrowIcon}
              alt={"back-icon"}
              width={35}
              height={35}
            />
          )}
          <Box>
            <Typography
              variant={"body1"}
              fontWeight={600}
              lineHeight={"normal"}
            >
              {title}
            </Typography>
            <Typography variant={"body2"} color={"custom.crayolaGrey"}>
              {subtitle}
            </Typography>
          </Box>
        </Stack>
        {headerActions && headerActions}
      </Stack>
      <Divider />
      {searchActions && searchActions}
      <Box p={"20px 20px"} {...childrenProps}>
        {children}
      </Box>
    </Paper>
  );
};

export default PaperContainer;
